import { ProviderUser } from './provider-user.model';
import { Provider } from './provider.model';

export class User {

  public id: string;
  public firstName: string;
  public lastName: string;
  public email: string;
  public username: string;
  public companyName: string;
  public companyTaxId: string;
  public companyPhone: string;
  public companyAddress: string;
  public companyEmail: string;
  public phone: string;
  public phoneVerified: boolean;
  public facebookId: string;
  public providerUsers: ProviderUser[] = [];
  public enteredByAdmin: boolean;
  public roles: string[] = [];
  public dateOfBirth: string;
  public created: string;
  public locale: string;
  
  public fjcAccountId: string;
  public fjcContactId: string;

  public readonly = false

  public admin = false
  public editorAccessLevelPerProviderSlug: {} = {}

  public readonly KITCHEN = 20;
  public readonly WAITER = 30;
  public readonly BOSS = 40;

  constructor(
    obj?: any 
  ) {
    this.id = obj && obj.id || null;
    this.firstName = obj && ( obj.firstname || obj.firstName ) || null;
    this.lastName = obj && ( obj.lastname || obj.lastName ) || null;
    this.companyName = obj && ( obj.companyName || obj.companyName ) || null;
    this.companyTaxId = obj && ( obj.companyTaxId || obj.companyTaxId ) || null;
    this.companyPhone = obj && ( obj.companyPhone || obj.companyPhone ) || null;
    this.companyAddress = obj && ( obj.companyAddress || obj.companyAddress ) || null;
    this.companyEmail = obj && ( obj.companyEmail || obj.companyEmail ) || null;
    this.email = obj && obj.contactEmail || null;
    this.username = obj && obj.email || null;
    this.phone = obj && obj.phone || null;
    this.phoneVerified = obj && obj.phoneVerified || null;
    this.locale = obj && obj.locale || null;
    this.facebookId = obj && obj.facebookId || null;
    this.roles = obj && obj.roles || null;
    this.enteredByAdmin = obj && obj.enteredByAdmin || null;
    this.dateOfBirth = obj && obj.dateOfBirth || null;

    if ( obj.providerUsers ) {

      for (let pu of obj.providerUsers ) {

       if ( pu instanceof ProviderUser ) {
         this.providerUsers.push( pu );
       } else {
         this.providerUsers.push( new ProviderUser( pu ) );
       }

      }

    }

    for (let pu of this.providerUsers ) {

      if (pu.provider && pu.provider.slug && pu.position && pu.position > 10 && !this.admin) {
        this.editorAccessLevelPerProviderSlug[ pu.provider.slug ] = [ pu.position, ( ( pu.editorOnlyAtLocation && pu.editorOnlyAtLocation.id ) ? pu.editorOnlyAtLocation.id: null ) ];
      }
      
    }

    if ( this.roles &&  ( this.roles[0] === 'ROLE_SUPER_ADMIN' || this.roles[0] === 'ROLE_ADMIN' ) ) {
      this.admin = true;
    } 
   
    this.created = obj && obj.created || null;
  }


  hasExperiencesAccess( userId: number ) {

    const allowedUsers = [ 577949,577952,624704,629398,695989,723437,737979, 1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17 ];
    return allowedUsers.includes( userId );

  }

  hasAtLeastAccessLevel( slug, level, realId = null ) {

    if ( this.admin ) {
      return true;
    }


    if ( !this.editorAccessLevelPerProviderSlug[ slug ] || undefined === this.editorAccessLevelPerProviderSlug[ slug ][0] || undefined === !this.editorAccessLevelPerProviderSlug[ slug ][1] ) {
      return false;
    }


    if ( this.editorAccessLevelPerProviderSlug[ slug ][0] < level && !this.admin ){
      return false;
    }


    if ( realId ) {

      if ( this.editorAccessLevelPerProviderSlug[ slug ][1] !== null && this.editorAccessLevelPerProviderSlug[ slug ][1] !== realId )  {
        return false;
      }      

    }

    return true;

    //return ( this.editorAccessLevelPerProviderSlug[ slug ][0] >= level && ( null == realId || this.editorAccessLevelPerProviderSlug[ slug ][0]  === null) || this.admin;

  }

  composeFullName( addCompany = false ) {

    let name: string;

    if ( this.firstName ) {
      name = this.firstName;
    }

    if ( this.lastName ) {

      if ( name ) {
        name += ' ' + this.lastName ;

      } else {

        name = this.lastName;

      }

    }

    if ( this.companyName ) {

      if (name) {
        return name + ' ' + this.companyName;
      } else {
        this.companyName;
      }


    }

    return name;

  }



  getProviderUserForProvider( provider: Provider, setUserField = true ) {

    for (let pu of this.providerUsers ) {

      if ( pu.provider.id == provider.id ) {
        
        if ( setUserField ) {
          pu.user = this;
        }

        return pu;
      }
      
    }

    return;

  }

  getProviderUserForProviderId( providerId: string, setUserField = true ) {

    for (let pu of this.providerUsers ) {

      if ( pu.provider.id == providerId ) {
        if ( setUserField ) {
          pu.user = this;
        }
        
        return pu;
      }
      
    }

    return;

  }

}